import { capitalize } from 'SRC/utils'

export const getFilterValues = (filter) => {
  const filterValues = {}
  for (let field in filter) {
    if (typeof filter[field] !== 'object') {
      const omit = ['id', 'user', 'updatedAt', 'createdAt']
      if (!omit.includes(field)) filterValues[field] = filter[field]
    } else {
      if (filter[field]) {
        switch (field) {
          case 'parentCategory':
          case 'category':
          case 'group':
            break
          case 'brands':
          case 'products':
            const values = filter[field].map(item => item.id)
            filterValues[field] = JSON.stringify(values)
            break
          case 'brand':
          case 'product':
          case 'service':
          case 'serviceType':
          case 'country':
          case 'city':
          case 'region':
          case 'location':
            filterValues[field] = filter[field].id
            break
          case 'cities':
            if (Array.isArray(filter[field])) {
              const citiesIds = filter[field].map(city => Number(city.id))
              filterValues[field] = JSON.stringify(citiesIds)
            }
            break
          case 'equipment':
            if (filter[field].length) {
              const equipmentIds = filter[field].map(eq => eq.id)
              filterValues[field] = JSON.stringify(equipmentIds)
            }
            break
          case 'swapps':
            const swappFields = {}
            if (filter[field].category) swappFields.category = filter[field].category.id
            if (filter[field].brand) swappFields.brand = filter[field].brand.id
            if (filter[field].product) swappFields.product = filter[field].product.id
            if (filter[field].specification1) {
              swappFields.specification1 = filter[field].specification1.id
              swappFields.specificationValue1 = filter[field].specificationValue1
            }
            filterValues[field] = JSON.stringify(swappFields)
            break
          case 'sortBy':
            if (typeof filter[field] === 'object' && filter[field].specification) {
              filterValues[field] = JSON.stringify({
                specification: filter[field].specification.id,
                order: filter[field].order
              })
            } else {
              if (typeof filter[field] === 'object') {
                filterValues[field] = `${filter[field].by}${capitalize(filter[field].order)}`
              } else {
                filterValues[field] = filter[field]
              }
            }
            break
          case 'specifications':
            if (filter[field].length) {
              const specs = []
              for (const spec of filter[field]) {
                const specId = spec.id.id
                if (spec.value) specs.push({id: specId, value: spec.value})
                if (spec.values) specs.push({id: specId, values: spec.values})
                if (spec.range) specs.push({id: specId, range: spec.range})
              }
              filterValues[field] = JSON.stringify(specs)
            }
            break
          default:
            filterValues[field] = JSON.stringify(filter[field])
            break
        }
      }
    }
  }
  return filterValues
}
